// src/components/forms/ReportingEntityInformation.jsx
import React from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

export default function ReportingEntityInformation() {
    const theme = useTheme();
    const today = new Date().toISOString().slice(0, 10);
    const nowTime = new Date().toLocaleTimeString('en-US', {
        hour: '2-digit',
        minute: '2-digit',
    });

    return (
        <Box mb={4}>
            {/* SC DPH�branded gradient header */}
            <Box
                sx={{
                    mb: 2,
                    p: 1,
                    borderRadius: 1,
                    background: `linear-gradient(135deg, ${theme.palette.primary.main} 0%, ${theme.palette.secondary.main} 100%)`,
                }}
            >
                <Typography variant="h6" color="white">
                    Reporting Facility or Individual Information
                </Typography>
            </Box>

            <Grid container spacing={2}>
                <Grid item xs={12} sm={3}>
                    <TextField
                        label="Current Date"
                        type="date"
                        fullWidth
                        defaultValue={today}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        label="Current Time"
                        type="time"
                        fullWidth
                        defaultValue={nowTime}
                        InputLabelProps={{ shrink: true }}
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        label="Phone"
                        fullWidth
                        placeholder="(123) 456-7890"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <TextField
                        label="Fax"
                        fullWidth
                        placeholder="(123) 456-7890"
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField
                        label="Name of Reporting Entity"
                        helperText="(i.e. Animal Control / DVM / Individual / Physician / Law Enforcement / Nurse, etc.)"
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField label="Facility Name" fullWidth />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField label="Email" type="email" fullWidth required />
                </Grid>
            </Grid>
        </Box>
    );
}
